const readNotification = async(): Promise<void> => {
    try {
        await new Promise(resolve => {
            setTimeout(resolve, 3000);
        });

        const response = await fetch('/api/Members/current/notifications/read', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
        });

        if (!response.ok) {
            throw new Error('Failed to mark notifications as read');
        }
    } catch (error) {
        console.error(error);
    }
};

interface NotificationsInitProps {
    el: HTMLElement;
}

const Notifications = ({ el }: NotificationsInitProps): void => {
    if (el) {
        readNotification().catch(() => {
            console.error('Error marking notifications as read');
        });
    }
};

export default Notifications;
